<template>
<svg data-svg-lvl-2="spread-back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersSpreadBackContourM22 :params="params" v-if="!params.isFlap7" />
<PreviewLayersSpreadBackContourM22_F7 :params="params" v-if="params.isFlap7" />
<component :params="params" :is="`PreviewLayersSpreadBackCorners${params.cornersBackComponent}`" v-if="params.cornersBackComponent" />
<component :params="params" :is="`PreviewLayersSpreadBackLabelM2`" v-if="params.label.enabled" />
<component :is="`PreviewLayersSpreadBackFlapF${params.flapComponent}`" :params="params" v-if="params.flapComponent" />
<component :is="`PreviewLayersSpreadBackLoopL${params.loopComponent}`" :params="params" v-if="params.loopComponent" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>